<template>
<div @click.stop.prevent>

<v-menu offset-y left :close-on-content-click="false" v-model="calendarVisible">
    <template v-slot:activator="{ on }">   
        <div v-on="on">

            <div v-if="task.due" class="due-chip" v-ripple  :style="{'background-color': dueColour, opacity: dueOpacity}">
                <ContactImage v-if="task.assigned" :contact="task.assigned" :size="28" emptyTooltip="Not Assigned"/>

                <div class="due-content">
                    {{fromNow(task.due)}}
                </div>
            </div>  

            <div class="hoverable round pa-1" v-if="!task.due" icon>
                <v-icon color="grey lighten-1" >event</v-icon>
            </div>
        </div>
    </template>
    
    <div class="white-background columns-on-wide popup-content">
        <v-date-picker v-model="backwardsDate" no-title scrollable flat @input="calendarVisible = false" />
        <div v-if="task.due" style="padding:10px 10px 10px 10px;border:solid 1px #ddd;width:290px;overflow-y:auto">
            <div v-for="contact in contacts" class="inline-block" style="margin:3px;" :key="contact._id" @click="task.assigned=contact;calendarVisible=false">
                <ContactImage :size="48" :contact="contact"  />
            </div>
            <v-btn @click="clearSchedule()" color="red" text rounded style="width: 105px;margin-top:5px">Clear</v-btn>
        </div>
    </div>

</v-menu>  


</div>
 
</template>

<script>
import DateHelpers from '@/helpers/DateHelpers'
import { differenceInBusinessDays } from 'date-fns'
import ContactHelpers from '../../helpers/ContactHelpers'
import ContactImage from './ContactImage'
import Firestore from '../../data/Firestore'
import DataHelpers from '../../helpers/DataHelpers'

export default {
    data() {
        return {
            calendarVisible: false,
            contacts: [
                {
                    _id: Firestore.getId(),
                    firstName: 'Linda',
                    lastName: 'Ireland',
                    image: ContactHelpers.getSampleImage('female')
                },
                {
                    _id: Firestore.getId(),
                    firstName: 'Peta',
                    lastName: 'Short',
                    image: ContactHelpers.getSampleImage('female')
                },
                {
                    _id: Firestore.getId(),
                    firstName: 'Bill',
                    lastName: 'Jaemeison',
                },
                {
                    _id: Firestore.getId(),
                    firstName: 'James',
                    lastName: 'Squire',
                    image: ContactHelpers.getSampleImage('male')
                },
                {
                    _id: Firestore.getId(),
                    firstName: 'Harriet',
                    lastName: 'Constantino',
                    image: ContactHelpers.getSampleImage('female')
                },
                {
                    _id: Firestore.getId(),
                    firstName: 'Jonothon',
                    lastName: 'Draper',
                },
            ]
        }
    },

    components: {
        ContactImage,
    },
    
    props: {
        task: Object,
    },

    computed: {
        backwardsDate: {
            get() {
                return DateHelpers.dateToBackwards(this.task.due)
            }, 
            set(val) {
                this.$set(this.task, 'due', DateHelpers.backwardsToDate(val) )
                if(!this.task.assigned)
                    this.$set(this.task, 'assigned', DataHelpers.getUser() )
            }
        },

        dueDays() {
            return differenceInBusinessDays(this.task.due, new Date())
        },
        dueOpacity() {
            if(this.dueDays < 2)
                return .9
            if(this.dueDays < 4)
                return .6
            return .4

        },
        dueColour() {
            if(this.dueDays == 0)
                return '#2E9AFE'  //blue
            if(this.dueDays < 0)
                return '#FE2E64'  //red
            return '#848484'    //grey
        },
        


    },

    methods: {
        fromNow(dt) {
            return DateHelpers.fromNow(dt)
        },
        clearSchedule() {
            this.$delete(this.task, 'due')
            this.$delete(this.task, 'assigned')
            this.calendarVisible = false
        },
    },

    created() {
        
    }
}
</script>

<style scoped>
.due-chip {
    display:flex;
    align-items: center;
    justify-content: center;
    padding:2px;
    background-color:#ccc;
    color: white;
    border-radius: 999px;
    width:110px;
    font-size:14px;
    transition: background-color 3s ease, opacity .3s ease;
}
.due-chip:hover {
    opacity: 1!important;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.4);
}

.due-content {
    padding:3px;
    flex-grow:1;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    
}
.popup-content {
    max-width:420px;
}

</style>




// WEBPACK FOOTER //
// DueIndicator.vue?87a70014